module.exports = __webpack_public_path__ + "components/rewards/isobaa/static/logo-5547b6cf0dbf67a38ce4260b44d8af50.webp";